export default {
    RA_CHECK_STATUS_FAILURE: 'RA_CHECK_STATUS_FAILURE',
    RA_CHECK_STATUS_REQUEST: 'RA_CHECK_STATUS_REQUEST',
    RA_CHECK_STATUS_SUCCESS: 'RA_CHECK_STATUS_SUCCESS',
    RA_CUSTOM_PLAN_BY_OBJECTIVE_DATA_FROM_SIMULATION: 'RA_CUSTOM_PLAN_BY_OBJECTIVE_DATA_FROM_SIMULATION',
    RA_CUSTOM_PLAN_BY_OBJECTIVE_SET_CONTRIBUTION_DAY: 'RA_CUSTOM_PLAN_BY_OBJECTIVE_SET_CONTRIBUTION_DAY',
    RA_CUSTOM_PLAN_BY_OBJECTIVE_SET_INITIAL_CONTRIBUTION_AMOUNT:
        'RA_CUSTOM_PLAN_BY_OBJECTIVE_SET_INITIAL_CONTRIBUTION_AMOUNT',
    RA_CUSTOM_PLAN_BY_OBJECTIVE_SET_OBJECTIVE_AMOUNT: 'RA_CUSTOM_PLAN_BY_OBJECTIVE_SET_OBJECTIVE_AMOUNT',
    RA_CUSTOM_PLAN_BY_OBJECTIVE_SET_OBJECTIVE_END_DATE: 'RA_CUSTOM_PLAN_BY_OBJECTIVE_SET_OBJECTIVE_END_DATE',
    RA_CUSTOM_PLAN_BY_OBJECTIVE_SET_PERIODICITY: 'RA_CUSTOM_PLAN_BY_OBJECTIVE_SET_PERIODICITY',
    RA_CUSTOM_PLAN_BY_OBJECTIVE_SET_RECURRING_CONTRIBUTION_AMOUNT:
        'RA_CUSTOM_PLAN_BY_OBJECTIVE_SET_RECURRING_CONTRIBUTION_AMOUNT',
    RA_CUSTOM_PLAN_BY_OBJECTIVE_SET_SELECTED_STRATEGY: 'RA_CUSTOM_PLAN_BY_OBJECTIVE_SET_SELECTED_STRATEGY',
    RA_CUSTOM_PLAN_BY_OBJECTIVE_UPDATE_DESCRIPTION: 'RA_CUSTOM_PLAN_BY_OBJECTIVE_UPDATE_DESCRIPTION',
    RA_EXPECTED_PROFITABILITY_CHANGE_YEARS: 'RA_EXPECTED_PROFITABILITY_CHANGE_YEARS',
    RA_EXPECTED_PROFITABILITY_CHART_FAILURE: 'RA_EXPECTED_PROFITABILITY_CHART_FAILURE',
    RA_EXPECTED_PROFITABILITY_CHART_REQUEST: 'RA_EXPECTED_PROFITABILITY_CHART_REQUEST',
    RA_EXPECTED_PROFITABILITY_CHART_SUCCESS: 'RA_EXPECTED_PROFITABILITY_CHART_SUCCESS',
    RA_HIRE_MANAGEMENT_PLAN_SET_PDF: 'RA_HIRE_MANAGEMENT_PLAN_SET_PDF',
    RA_MANAGEMENT_PLAN_GET_INVESTMENT_PROFILE_FAILURE: 'RA_MANAGEMENT_GET_INVESTMENT_PROFILE_FAILURE',
    RA_MANAGEMENT_PLAN_GET_INVESTMENT_PROFILE_REQUEST: 'RA_MANAGEMENT_GET_INVESTMENT_PROFILE_REQUEST',
    RA_MANAGEMENT_PLAN_GET_INVESTMENT_PROFILE_SUCCESS: 'RA_MANAGEMENT_PLAN_GET_INVESTMENT_PROFILE_SUCCESS',
    RA_MANAGEMENT_PLAN_RESET: 'RA_MANAGEMENT_PLAN_RESET',
    RA_MANAGEMENT_PLAN_SELECT_STRATEGY: 'RA_MANAGEMENT_PLAN_SELECT_STRATEGY',
    RA_MANAGEMENT_PLAN_SET_CONTRIBUTION_DAY: 'RA_MANAGEMENT_PLAN_SET_CONTRIBUTION_DAY',
    RA_MANAGEMENT_PLAN_SET_INITIAL_CONTRIBUTION_AMOUNT: 'RA_MANAGEMENT_PLAN_SET_INITIAL_CONTRIBUTION_AMOUNT',
    RA_MANAGEMENT_PLAN_SET_PERIODICITY: 'RA_MANAGEMENT_PLAN_SET_PERIODICITY',
    RA_MANAGEMENT_PLAN_SET_RECURRING_CONTRIBUTION_AMOUNT: 'RA_MANAGEMENT_PLAN_SET_RECURRING_CONTRIBUTION_AMOUNT',
    RA_MANAGEMENT_PLAN_SET_HAS_RECURRING_CONTRIBUTION: 'RA_MANAGEMENT_PLAN_SET_HAS_RECURRING_CONTRIBUTION',
    RA_MANAGEMENT_PLAN_SHOW_DETAILS: 'RA_MANAGEMENT_PLAN_SHOW_DETAILS',
    RA_PORTFOLIO_DISTRIBUTION_GET_DISTRIBUTION_FAILURE: 'RA_PORTFOLIO_DISTRIBUTION_GET_DISTRIBUTION_FAILURE',
    RA_PORTFOLIO_DISTRIBUTION_GET_DISTRIBUTION_REQUEST: 'RA_PORTFOLIO_DISTRIBUTION_GET_DISTRIBUTION_REQUEST',
    RA_PORTFOLIO_DISTRIBUTION_GET_DISTRIBUTION_SUCCESS: 'RA_PORTFOLIO_DISTRIBUTION_GET_DISTRIBUTION_SUCCESS',
    RA_SET_ERROR_COHERENCE_VALIDATION: 'RA_SET_ERROR_COHERENCE_VALIDATION',
    RA_SET_FROM_SET_GOAL: 'RA_SET_FROM_SET_GOAL',
    RA_SET_GOAL_ERROR: 'RA_SET_GOAL_ERROR',
    RA_SET_GOAL_GET_DATA_FROM_SIMULATION: 'RA_SET_GOAL_GET_DATA_FROM_SIMULATION',
    RA_SET_GOAL_REQUEST: 'RA_SET_GOAL_REQUEST',
    RA_SET_GOAL_RESET: 'RA_SET_GOAL_RESET',
    RA_SET_GOAL_SET_INVESTMENT_GOAL_VALUE: 'RA_SET_GOAL_SET_INVESTMENT_GOAL_VALUE',
    RA_SET_GOAL_SET_VISIBLE_STEP: 'RA_SET_GOAL_SET_VISIBLE_STEP',
    RA_SET_GOAL_SUCCESS: 'RA_SET_GOAL_SUCCESS',
    RA_SET_GOAL_VALIDATE_UI_STEP: 'RA_SET_GOAL_VALIDATE_UI_STEP',
    RA_SIMULATION_REQUEST: 'RA_SIMULATION_REQUEST',
    RA_SIMULATION_REQUEST_FAILURE: 'RA_SIMULATION_REQUEST_FAILURE',
    RA_SIMULATION_REQUEST_SUCCESS: 'RA_SIMULATION_REQUEST_SUCCESS',
    RA_SIMULATION_SAVE: 'RA_SIMULATION_SAVE',
    RA_SIMULATION_SAVE_FAILURE: 'RA_SIMULATION_SAVE_FAILURE',
    RA_SIMULATION_SAVE_SUCCESS: 'RA_SIMULATION_SAVE_SUCCESS',
    RA_SUITABILITY_GET_TEST_QUESTIONS_FAILURE: 'RA_SUITABILITY_GET_TEST_QUESTIONS_FAILURE',
    RA_SUITABILITY_GET_TEST_QUESTIONS_REQUEST: 'RA_SUITABILITY_GET_TEST_QUESTIONS_REQUEST',
    RA_SUITABILITY_GET_TEST_QUESTIONS_SUCCESS: 'RA_SUITABILITY_GET_TEST_QUESTIONS_SUCCESS',
    RA_SUITABILITY_GET_TEST_RESULT_FAILURE: 'RA_SUITABILITY_GET_TEST_RESULT_FAILURE',
    RA_SUITABILITY_GET_TEST_RESULT_REQUEST: 'RA_SUITABILITY_GET_TEST_RESULT_REQUEST',
    RA_SUITABILITY_GET_TEST_RESULT_SUCCESS: 'RA_SUITABILITY_GET_TEST_RESULT_SUCCESS',
    RA_SUITABILITY_TEST_EXPAND_ACCORDION_ROW: 'RA_SUITABILITY_TEST_EXPAND_ACCORDION_ROW',
    RA_SUITABILITY_TEST_RELOAD_OTP: 'RA_SUITABILITY_TEST_RELOAD_OTP',
    RA_SUITABILITY_TEST_RESET: 'RA_SUITABILITY_TEST_RESET',
    RA_SUITABILITY_TEST_RESET_ANSWERS: 'RA_SUITABILITY_TEST_RESET_ANSWERS',
    RA_SUITABILITY_TEST_RESET_COHERENCE_ERROR: 'RA_SUITABILITY_TEST_RESET_COHERENCE_ERROR',
    RA_SUITABILITY_TEST_RESET_TEST_COMPLETED: 'RA_SUITABILITY_TEST_RESET_TEST_COMPLETED',
    RA_SUITABILITY_TEST_SELECT_ACCORDION_BUTTON: 'RA_SUITABILITY_TEST_SELECT_ACCORDION_BUTTON',
    RA_SUITABILITY_TEST_UPDATE_ANSWER_BY_QUESTION_ID: 'RA_SUITABILITY_TEST_UPDATE_ANSWER_BY_QUESTION_ID',
    RA_SUITABILITY_TEST_SEND_TEST_EMAIL_FAILURE: 'RA_SUITABILITY_TEST_SEND_TEST_EMAIL_FAILURE',
    RA_SUITABILITY_TEST_SEND_TEST_EMAIL_IN_PROGRESS: 'RA_SUITABILITY_TEST_SEND_TEST_EMAIL_IN_PROGRESS',
    RA_SUITABILITY_TEST_SEND_TEST_EMAIL_SUCCESS: 'RA_SUITABILITY_TEST_SEND_TEST_EMAIL_SUCCESS',
    RA_SUITABILITY_TEST_SEND_TEST_FAILURE: 'RA_SUITABILITY_TEST_SEND_TEST_FAILURE',
    RA_SUITABILITY_TEST_SEND_TEST_IN_PROGRESS: 'RA_SUITABILITY_TEST_SEND_TEST_IN_PROGRESS',
    RA_SUITABILITY_TEST_SEND_TEST_SUCCESS: 'RA_SUITABILITY_TEST_SEND_TEST_SUCCESS',
    RA_SUITABILITY_TEST_SIGN_TEST_FAILURE: 'RA_SUITABILITY_TEST_SIGN_TEST_FAILURE',
    RA_SUITABILITY_TEST_SIGN_TEST_REQUEST: 'RA_SUITABILITY_TEST_SIGN_TEST_REQUEST',
    RA_SUITABILITY_TEST_SIGN_TEST_SUCCESS: 'RA_SUITABILITY_TEST_SIGN_TEST_SUCCESS',
    RA_SUITABILITY_TEST_UPDATE_CAPITAL: 'RA_SUITABILITY_TEST_UPDATE_CAPITAL',
    RA_SUITABILITY_TEST_UPDATE_EXPENSES_VALUE: 'RA_SUITABILITY_TEST_UPDATE_EXPENSES_VALUE',
    RA_SUITABILITY_TEST_UPDATE_INCOMING_VALUE: 'RA_SUITABILITY_TEST_UPDATE_INCOMING_VALUE',
    RA_SUITABILITY_TEST_UPDATE_INVESTMENT_HORIZON_SLIDER: 'RA_SUITABILITY_TEST_UPDATE_INVESTMENT_HORIZON_SLIDER',
    RA_SUITABILITY_TEST_UPDATE_OUTGOING_VALUE: 'RA_SUITABILITY_TEST_UPDATE_OUTGOING_VALUE',
    RA_SUITABILITY_TEST_UPDATE_VOLATILITY_INPUT_VALUE: 'RA_SUITABILITY_TEST_UPDATE_VOLATILITY_INPUT_VALUE',
    RA_SUITABILITY_TEST_UPDATE_VOLATILITY_VALUE: 'RA_SUITABILITY_TEST_UPDATE_VOLATILITY_VALUE',
    RA_SUITABILITY_TEST_VALIDATE_OTP: 'RA_SUITABILITY_TEST_VALIDATE_OTP',
    RA_SUITABILITY_TEST_VALIDATE_OTP_ERROR: 'RA_SUITABILITY_TEST_VALIDATE_OTP_ERROR',
    RA_SUITABILITY_TEST_VALIDATE_OTP_SUCCESS: 'RA_SUITABILITY_TEST_VALIDATE_OTP_SUCCESS',
    RA_TEST_FETCH_STEPS: 'RA_TEST_FETCH_STEPS',
    RA_TEST_FINALIZE_STEP: 'RA_TEST_FINALIZE_STEP',
    RA_TEST_FINALIZE_SUBSTEP: 'RA_TEST_FINALIZE_SUBSTEP',
    RA_TEST_GOTO_STEP: 'RA_TEST_GOTO_STEP',
    RA_TEST_GOTO_SUB_STEP: 'RA_TEST_GOTO_SUB_STEP',
    RA_TEST_NEXT_STEP: 'RA_TEST_NEXT_STEP',
    RA_TEST_PREV_STEP: 'RA_TEST_PREV_STEP',
    RA_TEST_RETAKE_TEST: 'RA_TEST_RETAKE_TEST',
    RA_TIME_HORIZON_CHECK_FAILURE: 'RA_TIME_HORIZON_CHECK_FAILURE',
    RA_TIME_HORIZON_CHECK_REQUEST: 'RA_TIME_HORIZON_CHECK_REQUEST',
    RA_TIME_HORIZON_CHECK_RESET_TIME_HORIZON_CHECK: 'RA_TIME_HORIZON_CHECK_RESET_TIME_HORIZON_CHECK',
    RA_TIME_HORIZON_CHECK_SET_TIME: 'RA_TIME_HORIZON_CHECK_SET_TIME',
    RA_TIME_HORIZON_CHECK_SUCCESS: 'RA_TIME_HORIZON_CHECK_SUCCESS',
    RA_UPDATE_SELECTED_GOAL: 'RA_UPDATE_SELECTED_GOAL',
    RA_SIMULATION_UPDATE_SIMULATION: 'RA_SIMULATION_UPDATE_SIMULATION',
    RA_SAVE_GOAL_ONBOARDING_SUCCESS: 'RA_SAVE_GOAL_ONBOARDING_SUCCESS',
    RA_SAVE_GOAL_ONBOARDING_FAILURE: 'RA_SAVE_GOAL_ONBOARDING_FAILURE',
    RA_SAVE_GOAL_ONBOARDING_REQUEST: 'RA_SAVE_GOAL_ONBOARDING_REQUEST',
    RA_GET_GOAL_ONBOARDING_REQUEST: 'RA_GET_GOAL_ONBOARDING_REQUEST',
    RA_GET_GOAL_ONBOARDING_SUCCESS: 'RA_GET_GOAL_ONBOARDING_SUCCESS',
    RA_GET_GOAL_ONBOARDING_FAILURE: 'RA_GET_GOAL_ONBOARDING_FAILURE',
    RA_CUSTOM_PLAN_BY_OBJECTIVE_UPDATE_GOAL_ONBOARDING: 'RA_CUSTOM_PLAN_BY_OBJECTIVE_UPDATE_GOAL_ONBOARDING',
    RA_UPDATE_GOAL_FROM_SIMULATION: 'RA_UPDATE_GOAL_FROM_SIMULATION',
    RA_SUITABILITY_TEST_RESET_OTP: 'RA_SUITABILITY_TEST_RESET_OTP',
    RA_DELETE_GOAL_ONBOARDING_SUCCESS: 'RA_DELETE_GOAL_ONBOARDING_SUCCESS',
    RA_DELETE_GOAL_ONBOARDING_FAILURE: 'RA_DELETE_GOAL_ONBOARDING_FAILURE',
    RA_DELETE_GOAL_ONBOARDING_REQUEST: 'RA_DELETE_GOAL_ONBOARDING_REQUEST',
    RA_FILL_DEFAULT_ANSWERS_ACCORDION: 'RA_FILL_DEFAULT_ANSWERS_ACCORDION',
    RA_SKIP_TO_NEXT_TEST: 'RA_SKIP_TO_NEXT_TEST',
    RA_REMOVE_STEP_FROM_SKIPPED_STEPS: 'RA_REMOVE_STEP_FROM_SKIPPED_STEPS',
};
